import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { CompanySettingsPage } from "../../pages/settings/";
// import {customersEmployeesResource} from "../../resources/customer-employees";
import { customerUsers } from "../../resources/customer-users";
import { customerDriversResource } from "../../resources/drivers/";
import Messages from "../../resources/messages/List/List";
import {
	OrderEditByTransporter,
	OrderShowTabsWrapper,
	commonOrdersResourceData,
	ordersResource,
} from "../../resources/orders/";
import { transportTrailersResource } from "../../resources/trailers";
import { transportTrucksResource } from "../../resources/trucks";
import { readonlyThirdPartyAppsResource } from "../../resources/third-party-apps";
import { authenticatedResources } from "./authenticated";

export const transporterAdminResources = [
	<Resource
		name="orders"
		list={ordersResource.list}
		edit={OrderEditByTransporter}
		show={OrderShowTabsWrapper}
	/>,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource {...transportTrucksResource} name="trucks" />,
	<Resource {...transportTrailersResource} name="trailers" />,
	// <Resource {...customersEmployeesResource} name="customer-employees" />,
	<Resource {...customerUsers} name="customer-users" options={{ label: "Employees" }} />,
	<Resource name="ports" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="terminal" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist" intent="registration" />,
	<Resource name="drivers" {...customerDriversResource} />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="storage-places" intent="registration" />,
	<Resource name="storage-places-lookup" intent="registration" />,
	<Resource name="external-terminal-links" intent="registration" />,

	<Resource name="company-notifications" intent="registration" />,
	<Resource name="commodities" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="pallets-and-boxes" intent="registration" />,
	<Resource name="pallets" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,
	<Resource name="third-party-apps" {...readonlyThirdPartyAppsResource} />,

	...authenticatedResources,
];

export const transporterAdminRoutes = [
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/notifications" component={CompanySettingsPage} />,
];
